module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_17",
    attrs: {
      "id": "filepos54843"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_c('a', {
    staticClass: "calibre8"
  }), _vm._v("Preface")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("This work, like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fingers Pointing Towards the Moon")]), _vm._v(", is a series of observations on the path of a pilgrim, and represents a continual development of the intuitions and ideas so experienced.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Therefore at no point is a final statement of doctrine to be sought, which would indeed be dogma, and which this could never be.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("In this process later observations correct, supplement and achieve earlier ones, perhaps contradict them in certain details. Nowhere is absolute truth to be expected. Nowhere is anyone asked to believe. Nowhere is there finality to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("A pilgrim shares the fruit he has gathered by the wayside—that is all.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("It may be observed, even perhaps objected, that this later volume is increasingly concerned with two or three themes only. The inference should be clear: as the wayfarer proceeds, the broad base of the mountain is left behind, the path narrows and the multitudinous objects of apparent interest that abound at the lower levels merge into a few essential ones that ultimately will become one only—as may be observed in the concentrated teaching of those who arrived at the summit, such as Huang Po, Padma Sambhava and Ramana Maharshi. Were it not so even here the work could hardly be genuine or that little it professes to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Thereafter there are no further problems, for subsidiary "), _c('a'), _vm._v("ones are derivative, and ultimately there is nothing further to be said.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("All that remains is the catalystic understanding of that ultimate problem that the long wayfaring has revealed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_21"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("—W.W.W.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5a60760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_008.vue
// module id = 84
// module chunks = 0